import { CenteredContainer } from "@snapchat/web-core-ui";
import { CTAFooter, generateAttributedDownloadUrl, useDesktopMediaQuery } from "@snapchat/web-frame";
import { DEFAULT_LOCALE, getLocale } from "@snapchat/web-i18n";
import { Heading } from "@snapchat/web-sds-c";
import React, { useEffect, useState } from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { loadMessages } from "../../../i18n/messageLoader";
import { Reason } from "./constants";
import styles from "./NoContent.module.css";
function getMessageForReason(reason) {
    switch (reason) {
        case Reason.CONTENT_NOT_AVAILABLE_IN_LOCATION:
            return (<FormattedMessage id="9hiucJ" description="Text displayed on an error page when a user tries to see content that is not available in their location." defaultMessage="This content is not available in your location"/>);
        case Reason.CONTENT_NOT_FOUND:
            return (<FormattedMessage id="AtLF/u" description="Text displayed on an error page when a user tries to see content that wasn't found." defaultMessage="This content was not found"/>);
        case Reason.CONTENT_NOT_AVAILABLE:
            return (<FormattedMessage id="JbCR5V" description="Text displayed on an error page when a user tries to see content that is not available to them." defaultMessage="This content is not available"/>);
    }
}
function displayContentNotAvailableHeading() {
    return (<Heading size="H1">
      <span className={styles.title}>
        <FormattedMessage id="6yvoZD" description="Text displayed as a big heading on an error page when a user tries to see content that is not available to them." defaultMessage="Sorry,"/>
      </span>
    </Heading>);
}
function displaySubHeading(reason) {
    return (<Heading size="H5">
      <span className={styles.subtitle}>{getMessageForReason(reason)}</span>
    </Heading>);
}
function displayContent(reason) {
    return (<div className={styles.columnItem}>
      {displayContentNotAvailableHeading()}
      {displaySubHeading(reason)}
    </div>);
}
/**
 * A generic page to display when the requested content isn't available for some reason.
 */
export function NoContent({ locale, reason, changeLocale, pageType, hideFooter, }) {
    const preferredLocale = getLocale(locale);
    const [messages, setMessages] = useState({});
    const isDesktop = useDesktopMediaQuery();
    const NO_CONTENT_DESKTOP_TEST = "SnapchatDotCom_NoContentDesktop";
    const NO_CONTENT_MOBILE_TEST = "SnapchatDotCom_NoContentMobile";
    useEffect(() => {
        void loadMessages(preferredLocale).then((messages) => {
            setMessages(messages);
        });
    }, [preferredLocale]);
    return (<IntlProvider locale={preferredLocale} defaultLocale={DEFAULT_LOCALE} messages={messages}>
      <React.Fragment>
        <CenteredContainer>
          {isDesktop ? (<div className={styles.desktopContainer} data-testid={NO_CONTENT_DESKTOP_TEST}>
              {displayContent(reason)}
            </div>) : (<div className={styles.mobileContainer} data-testid={NO_CONTENT_MOBILE_TEST}>
              {displayContent(reason)}
            </div>)}
        </CenteredContainer>
        {hideFooter ? null : (<CTAFooter locale={preferredLocale} downloadUrl={generateAttributedDownloadUrl(pageType)} localeChange={changeLocale} pageType={pageType}/>)}
      </React.Fragment>
    </IntlProvider>);
}
